import { render, staticRenderFns } from "./SetPermissionProfileUserModal.vue?vue&type=template&id=7f4efc6e&lang=pug"
import script from "./SetPermissionProfileUserModal.vue?vue&type=script&lang=js"
export * from "./SetPermissionProfileUserModal.vue?vue&type=script&lang=js"
import style0 from "./SetPermissionProfileUserModal.vue?vue&type=style&index=0&id=7f4efc6e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports